$(function(){

    /*
    $('.btn-uploaden').click(function(e) {
        e.preventDefault();
        var id = $(this).data('id');
        $('input[data-id='+id+']').click();
        return false;
    });

    $('.file-upload').each(function() {
        var $this = $(this);
        $this.fileupload({
            replaceFileInput: false,
            url: $('.url').val(),
            formData: {
                order_regel_id: $this.data('id'),
                action: 'Upload',
                order_id: $this.data('order-id')
            },
            dataType: 'json',
            done: function (e, data) {
                var file = data.result.files[0];
                var $img = $this.closest('.winkelwagen-stap-1-product-foto').find('img');
                $img.attr('src', file.url);
                $img.slideDown('slow');
            },
            progressall: function (e, data) {

            },
            fail: function (e, data) {
                console.log(data);
            }
        }).prop('disabled', !$.support.fileInput)
            .parent().addClass($.support.fileInput ? undefined : 'disabled');
    });
    */

    $('.repeat-order').click(function(e) {
        e.preventDefault();
        var $this = $(this);
        var id = $this.data('id');

        $.post(window.location.href, { id: id, action: 'RepeatOrder' }, function(data) {
            var data = JSON.parse(data);
            if(data.status === 'success') window.location.href = data.url;
            if(data.status === 'error') {
                var errors = data.errors;
                var html = '<ul>';
                var i = 1;
                for (var error in errors) {
                    var e = data.errors[error];
                    html += '<li>Sticker '+ i + ': ' + e.msg + '</li>';
                    i++;
                }
                html += '</ul>';
                html += '<a href="'+data.url+'">Ga verder</a>';
                $.fancybox(html);
            }
        });
        return false;
    });
});
